<template>
  <el-dialog :width="width" :top="top" :title="title" :visible.sync="show"
    append-to-body :before-close="close" :close-on-click-modal="false" 
    :class="['dialog', {'title-show': !title}]" >
    <el-row style="text-align:center;">
      <img v-show='url' :src="url" />
      <div v-html="content"  :class="{'contentWrap':this.top == '15vh'}"></div>
      <div class="btnDia">
        <el-button v-if="btn" @click="sumbit">{{btn}}</el-button>
        <el-button v-if="btn2" class="btn-2" @click="sumbit2">{{btn2}}</el-button>
        <el-button v-if="btn3" class="btn-2" @click="sumbit3">{{btn3}}</el-button>
      </div>
    </el-row>
  </el-dialog>
</template>
<script>
export default {
  name: "Dialog",
  props: {
    title: { type: String, default: "" },
    // img: '',uncertified.png
    img: { type: String, default: "" },
    content: { type: String, default: "。。" },
    btn: { type: String, default: "" },
    btn2: { type: String, default: "" },
    btn3: { type: String, default: "" },
    show: { type: Boolean, default: false },
    width: { type: String, default: '340px' },
    top: { type: String, default: '30vh' },
  },
  computed: {
    url() {
      if(this.img){
        return require("../../assets/" + this.img)
      }
    }
  },
  methods: {
    sumbit() {
      this.$parent.dialogSumbitL();
    },
    sumbit2() {
      this.$parent.dialogSumbitR();
    },
    sumbit3() {
      this.$parent.dialogSumbitNew()
    },
    close() {
      this.$emit("dialogClose");
    }
  }
};
</script>
<style lang="scss" scoped>
.dialog {
  /deep/ .el-dialog__header {
    border-bottom: 1px solid #ebecef;
  }
  img {
    margin-bottom: 10px;
    height: 40px;
  }
  .contentWrap {
    text-align:justify;
    height: 555px;
    overflow-y: scroll;

  }
}
.title-show {
  /deep/ .el-dialog__header {
    display: none;
  }
}
</style>